export default __webpack_public_path__ + "static/casablanca-4-52a68d3182a0150201f64757cab6ab16.jpg";